import { render, staticRenderFns } from "./assignStudentsDialog.vue?vue&type=template&id=29ca7be0&scoped=true"
import script from "./assignStudentsDialog.vue?vue&type=script&lang=js"
export * from "./assignStudentsDialog.vue?vue&type=script&lang=js"
import style0 from "./assignStudentsDialog.vue?vue&type=style&index=0&id=29ca7be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca7be0",
  null
  
)

export default component.exports